const initFAQState = {
    choosenData: {},
};

const faqReducer = (state = initFAQState, action) => {
    if (action.type === 'SET_CHOSEN_DATA') {
        return {
            ...state,
            choosenData: action.choosenData,
        }
    }


    return state;
};

export default faqReducer;
